import { useEffect, useState } from 'react';
import { lastDays } from './ReportPage';

// Loads a report for the selected restaurant and date range (default: last 30 days).
export const useReport = (fetchReport, { restaurants, userId, authenticatedFetch }) => {
  const [restaurantId, setRestaurantId] = useState('');
  const [range, setRange] = useState(() => lastDays(30));
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const selectedId = restaurantId || restaurants[0]?.id;
  const validRange = Boolean(range.from && range.to && range.from <= range.to);

  useEffect(() => {
    if (!selectedId || !userId || !validRange) return undefined;
    let cancelled = false;
    setData(null);
    setError(null);
    fetchReport(selectedId, userId, range.from, range.to, authenticatedFetch)
      .then((result) => !cancelled && setData(result))
      .catch((err) => !cancelled && setError(err.message));
    return () => { cancelled = true; };
  }, [fetchReport, selectedId, userId, range.from, range.to, validRange, authenticatedFetch]);

  return {
    data,
    error,
    validRange,
    filters: { restaurants, restaurantId: selectedId, onRestaurantChange: setRestaurantId, range, onRangeChange: setRange },
  };
};
